import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

const container = document.getElementById("root") as HTMLElement;

/**
 * HYDRATE WHEN THE SERVER SENT MARKUP, MOUNT WHEN IT DID NOT — D-042.
 *
 * After the SSG step (`scripts/prerender.mjs`) the shipped HTML already holds a
 * fully rendered tree, and calling `createRoot().render()` on it would throw all
 * of that away and rebuild from scratch: a visible flash, wasted work, and the
 * "double render" the migration exists to avoid. `hydrateRoot` adopts the
 * existing DOM instead and only attaches behaviour.
 *
 * The branch is on `hasChildNodes()` rather than on a build flag because both
 * states are real and neither is exceptional: `vite dev` serves the unprocessed
 * index.html with an empty root and must mount, while the built artifact is
 * always pre-rendered and must hydrate. Keying off an env var would mean dev and
 * production disagreeing about which path is exercised.
 */
const tree = (
	<React.StrictMode>
		<App />
	</React.StrictMode>
);

if (container.hasChildNodes()) {
	ReactDOM.hydrateRoot(container, tree);
} else {
	ReactDOM.createRoot(container).render(tree);
}
